<template>
  <v-form v-model="dataIsValid">
    <v-row>
      <v-col cols="6" md="5" offset-md="1">
        <div class="mb-3 body-1 font-weight-medium" v-if="!editDisable">Введите информацию об объекте подключения</div>
      </v-col>
      <v-col cols="6" md="5" class="pt-7">
        <v-radio-group v-model="radioGroup">
          <v-radio
            v-for="(item, index) in radioItems"
            :key="index"
            :label="item.label"
            :value="item.value"
            :disabled="editDisable"
          ></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="6" md="4" offset-sm="1" class="pt-0">
        <div class="mb-3 body-1 font-weight-medium">Разрешенная мощность*</div>
        <v-text-field
          return-object
          v-model="permittedPower"
          outlined
          type="number"
          :disabled="editDisable"
          :rules="notEmptyRule.concat(isInteger)"
        ></v-text-field>

        <div class="mb-3 body-1 font-weight-medium">Наименование РЭС*</div>
        <v-select
          :items="resItems"
          v-model="resSelect"
          item-text="text"
          :loading="!resItems.length"
          :disabled="!resItems.length || editDisable"
          :rules="[it=>!!it.text||'Поле обязательно']"
          no-data-text="Загрузка"
          return-object
          outlined
        ></v-select>

        <div class="mb-3 body-1 font-weight-medium">Общая площадь домовладения*</div>
        <v-text-field v-model="totalArea" outlined type="number" :rules="notEmptyRule" :disabled="editDisable"></v-text-field>

        <div class="mb-3 body-1 font-weight-medium">Общее количество этажей*</div>
        <v-text-field
          v-model="numberStorey"
          outlined
          type="number"
          :disabled="editDisable"
          :rules="notEmptyRule.concat(isInteger)"
        ></v-text-field>

        <div class="mb-3 body-1 font-weight-medium">Количество этажей в доме*</div>
        <v-text-field
          v-model="floor"
          outlined
          type="number"
          :disabled="editDisable"
          :rules="notEmptyRule.concat(isInteger)"
        ></v-text-field>

        <div class="mb-3 body-1 font-weight-medium">Количество комнат домовладения*</div>
        <v-text-field
          v-model="numberRooms"
          :rules="notEmptyRule.concat(numberRoomsRules, isInteger)"
          outlined
          :disabled="editDisable"
        ></v-text-field>

        <div class="mb-3 body-1 font-weight-medium">Количество проживающих жильцов*</div>
        <v-text-field
          v-model="numberInhabitants"
          outlined
          type="number"
          :disabled="editDisable"
          :rules="notEmptyRule.concat(isInteger)"
        ></v-text-field>
      </v-col>
      <v-col cols="6" md="4" offset-sm="1" class="pt-0">
        <template v-if="radioGroup === 'cadastre'">
          <div class="mb-3 body-1 font-weight-medium">Кадастровый номер*</div>
          <v-text-field v-model="cadastralNumber" :rules="notEmptyRule" outlined :disabled="editDisable"></v-text-field>
        </template>
        <address-form
          v-else-if="radioGroup === 'address'"
          addressType="802740002"
          :income="objectAddress"
          @transferData="setAddress"
        ></address-form>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
  import AddressForm from "../components/partial/AddressForm";
  import { AxiosWrapper } from "@/assets/api/AxiosWrapper";
  import {mapState} from 'vuex'

  export default {
    props: ["income" ,'formData'],
    components: {
      AddressForm
    },
    data: () => ({
      // DATA
      objectAddress: null,
      cadastralNumber: null,
      floor: null, // num
      numberStorey: null,
      numberRooms: 0,
      numberInhabitants: null,
      totalArea: null,
      permittedPower: null,
      // res
      resGuid: null,
      resName: null,
      // auto complete
      resItems: [],
      // FORM SETTINGS
      dataIsValid: false, // Важное поле для работы визарда
      addressIsValid: false,
      radioGroup: "address",
      radioItems: [
        {
          label: "У объекта есть адрес",
          value: "address"
        },
        {
          label: "У объекта есть только кадастровый номер",
          value: "cadastre"
        }
      ],
      resSelect: {},
      // rules
      notEmptyRule: [value => !!value || "Поле обязательно"],
      numberRoomsRules: [value => value >= 0 || "Минимальное значение 0"],
      isInteger: [value => value % 1 === 0 || "Введите целое число"]
    }),
    computed : {
      ...mapState({
        editDisable: state => state.statements.editDisable
      })
    },
    methods: {
      transferData() {
        // DATA
        this.$emit("transfer", {
          objectAddress: this.objectAddress,
          cadastralNumber: this.cadastralNumber,
          floor: Number(this.floor),
          numberRooms: Number(this.numberRooms),
          numberStorey: Number(this.numberStorey),
          numberInhabitants: Number(this.numberInhabitants),
          totalArea: Number(this.totalArea),
          permittedPower: Number(this.permittedPower),
          resGuid: this.resGuid,
          resName: this.resName
        });
      },
      setValidation(value) {
        this.addressIsValid = value;
      },
      setAddress(payload) {
        this.objectAddress = {
          ...payload
        };
      },
      // ac
      getReses() {
        AxiosWrapper.post("GetReses").then(response => {
          this.resItems = response.data.reses;
          // set if selected
          if (this.resGuid && this.resName) {
            this.resSelect = {
              guid: this.resGuid,
              text: this.resName
            };
          }
        });
      }
    },
    created() {
      let keys = Object.keys(this.income);
      keys.forEach(key => {
        this[key] = this.income[key];
      });

      if (this.cadastralNumber) {
        this.radioGroup = "cadastre";
      } else if (this.objectAddress) {
        this.radioGroup = "address";
      }

      // load items for ac
      this.getReses();
    },
    watch: {
      dataIsValid: {
        immediate: true,
        handler: function(value) {
          this.$emit("lockFwdBtn", !value);
        }
      },
      resSelect: {
        immediate: true,
        handler: function(payload) {
          this.resGuid = payload.guid;
          this.resName = payload.text;
        }
      },
      radioGroup: {
        immediate: true,
        handler: function(value) {
          switch (value) {
            case "cadastre":
              this.objectAddress = {};
              break;
            case "address":
              this.cadastralNumber = null;
              break;
          }
        }
      }
    },
    mounted () {
      if (this.formData.permittedPower) {
        let keys = Object.keys(this.formData);
        keys.forEach(key => {
          this[key] = this.formData[key];
        });
      }
    }
  };
</script>
